import { useEffect, useState } from "react";
import { Loader2, Check, Trash2, Mail } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function MessagesAdmin({ onChange }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const res = await api.get("/contact"); setItems(res.data); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    try { await api.patch(`/contact/${id}/read`); load(); onChange?.(); } catch (e) { toast.error("Error"); }
  };
  const remove = async (id) => {
    if (!window.confirm("¿Eliminar este mensaje?")) return;
    try { await api.delete(`/contact/${id}`); toast.success("Mensaje eliminado"); load(); onChange?.(); } catch (e) { toast.error("Error"); }
  };

  if (loading) return <div className="bg-white border-2 border-slate-950 p-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin" /></div>;

  return (
    <div className="bg-white border-2 border-slate-950">
      <div className="border-b-2 border-slate-950 p-4 md:p-6">
        <div className="font-mono text-xs tracking-[0.3em] uppercase text-amber-600">Bandeja</div>
        <h2 className="font-display text-2xl font-bold uppercase tracking-tight">Mensajes de contacto</h2>
      </div>

      {items.length === 0 ? (
        <div className="p-16 text-center text-slate-500">
          <Mail className="w-12 h-12 mx-auto text-slate-300 mb-3" />
          <p className="font-display uppercase tracking-tight">Sin mensajes</p>
        </div>
      ) : (
        <ul>
          {items.map((m) => (
            <li key={m.id} data-testid={`message-${m.id}`} className={`p-5 border-b border-slate-200 flex flex-col gap-2 ${!m.is_read ? "bg-amber-50/40" : ""}`}>
              <div className="flex items-center justify-between gap-3 flex-wrap">
                <div className="flex items-center gap-3">
                  {!m.is_read && <span className="w-2 h-2 bg-amber-500 rounded-full" />}
                  <span className="font-display font-bold uppercase tracking-tight">{m.name}</span>
                  <span className="text-xs font-mono text-slate-500">{m.email}</span>
                  {m.company && <span className="text-xs font-mono text-slate-400">· {m.company}</span>}
                </div>
                <div className="flex items-center gap-1">
                  <span className="text-[10px] font-mono uppercase tracking-wider text-slate-400">
                    {new Date(m.created_at).toLocaleString("es-CL")}
                  </span>
                  {!m.is_read && (
                    <button onClick={() => markRead(m.id)} data-testid={`mark-read-${m.id}`} title="Marcar leído" className="p-2 hover:bg-slate-100">
                      <Check className="w-4 h-4 text-slate-700" />
                    </button>
                  )}
                  <button onClick={() => remove(m.id)} data-testid={`delete-message-${m.id}`} title="Eliminar" className="p-2 hover:bg-red-50 text-red-600">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
              {m.phone && <div className="text-xs font-mono text-slate-500">Tel: {m.phone}</div>}
              <p className="text-sm text-slate-700 whitespace-pre-wrap">{m.message}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
